// extracted by mini-css-extract-plugin
export default {"status":"Order_status__zstv-","cancelledStatus":"Order_cancelledStatus__XOFUj"};